import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f65795f6558f0014d83ae5/resumevault/src/app/sign-up-login-screen/components/AuthScreen.tsx");
